import { reallyTruthy } from '@mote/helpers/validation'

const queryString = require('query-string')
const ago = require('s-ago')

const LOG_START = Date.now()
const LOG_WITH_TIME = true

export const EpochToAgo = e => {
  if (!e) {
    return ''
  }
  return ago(new Date(1000 * e))
}

export const EpochToPrettyDate = e => {
  if (!e) {
    return ''
  }
  const d = new Date(e * 1000)
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear()
}

export const log = (m, ...o) => {
  // var caller = "unknown";
  // try {
  // caller = new Error().stack.split("\n")[2].trim().split(" ")[1];
  // } catch (e) {}

  var timePrefix = ''
  if (LOG_WITH_TIME) {
    timePrefix =
      '[' + (Date.now() - LOG_START).toString().padStart(6, '0') + ']'
  }

  // console.log(`${timePrefix} [${caller}]: ` + m);
  console.log(`${timePrefix} ` + m)
  if (o) {
    for (var oo of o) {
      console.dir(oo)
    }
  }
}

export const noLog = () => {} /// use "import {noLog as log}" to suppress logging noise

export const getTZOffset = () => {
  return new Date().getTimezoneOffset()
}

export const validEmail = e => {
  const pattern =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
  return pattern.test(e)
}

export const yesno = b => {
  return reallyTruthy(b) ? 'yes' : 'no'
}

export const shortenWithEllipsis = (s, n) => {
  if (s.length > n) {
    return s.substring(0, n) + ' ... '
  } else {
    return s
  }
}

export const getGodModeOptions = () => {
  // log("search location: " + window.location.search);
  var querySearch = queryString.parse(window.location.search)
  // log("querySearch : ", querySearch);
  const adminOptions = {}
  if (querySearch.iid) {
    adminOptions.institutionIdByAdmin = querySearch.iid
  } else if (querySearch.uid) {
    adminOptions.userIdByAdmin = querySearch.uid
  }
  // log("returning : ", adminOptions);
  return adminOptions
}

export const getGodModeOptionsForState = () => {
  const options = getGodModeOptions()
  return {
    inGodMode: Object.keys(options).length > 0 ? true : false,
    godModeOptions: options
  }
}

export const getGodModeURLSuffix = institutionId => {
  // log("computing URL ...");
  const options = getGodModeOptionsForState()
  // log("options are ", options);
  if (options.inGodMode) {
    var o = options.godModeOptions
    // log("we are in god mode with ", o);
    if (o.institutionIdByAdmin) {
      return '?iid=' + o.institutionIdByAdmin
    } else if (institutionId) {
      return '?iid=' + institutionId
    } else if (o.userIdByAdmin) {
      return '?uid=' + o.userIdByAdmin
    }
  }
  return ''
}
